import React from 'react'
import styled, { css } from 'styled-components'
import { ExchangeBox } from '~/components/Layout'
import { Box } from '../Box'
import { BoxProps } from '../Box/types'

export interface ITradeForm {
  className?: string
  banner?: React.ReactNode
  mode?: 'root' | 'overlay'

  /**
   * only used when mode is 'overlay'
   */
  onBack?: () => void
  /**
   * only used when mode is 'overlay'
   */
  title?: string

  visible?: boolean

  headerRight?: React.ReactNode
  icon?: 'back' | 'close' | null
  nest?: boolean
}

export const TradeForm: React.FC<ITradeForm> = ({
  className,
  banner,
  children,
  onBack,
  mode = 'root',
  title,
  headerRight,
  visible,
  icon,
}) => {
  const Container = mode === 'root' ? TradeFormBody : TradeFormBox
  return (
    <>
      <ExchangeBox className={className}>
        {banner}
        <Container
          title={title}
          onBack={onBack}
          icon={icon}
          visible={visible}
          headerRight={headerRight}
        >
          {children}
        </Container>
      </ExchangeBox>
    </>
  )
}

export const StyleFormBody = css`
  align-items: flex-start;
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  width: 45vw;
  height: 100%;
  max-width: 435px;
  padding: 25px 15px 20px;
  position: relative;

  ${({ theme }) => theme.media.lg`
    width: 100% !important;
  `}
`

export const TradeFormBody = styled.div`
  ${StyleFormBody}
`

export const TradeFormBox: React.FC<BoxProps> = ({ children, ...props }) => {
  return (
    <Box {...props}>
      <TradeFormBody>{children}</TradeFormBody>
    </Box>
  )
}
